import React from "react";
import { useSelector } from "react-redux";

import { Button } from "../../../common/u1/Button";
import { UploadIcon } from "../../../../assets/ui/icons";
import { SectionNotice } from "./SectionNotice";
import { statusLadder } from "../../../public/Company/u1/profileStatus";
import { isMemberStatus } from "../../../public/Payment/u1/planFields";

/* "Get this section verified — free with your membership".
 *
 * ONE copy of a banner that was written out six times, identically, in
 * Banking, Insurance, Tax, Ownership, People and Relations. That duplication is
 * why this had to be gated in six places to be gated at all; now it is gated
 * once, here.
 *
 * THE GATE. The offer says the verification is free WITH YOUR MEMBERSHIP, so
 * it is shown only to a company that has one. A non-member, a new user or a
 * guest is promised nothing they cannot have — they saw the banner before and
 * it was simply untrue for them.
 *
 * The signal is the same one the rest of the app uses, not a new one:
 *
 *   statusLadder(company)  — TIP-505's membership-aware ladder, which reads
 *                            the backend's own `profile_status` and falls back
 *                            to the legacy chain when that field is absent.
 *   isMemberStatus(...)    — "member" or "verified", the predicate the plan
 *                            picker already branches on.
 *
 * A company already VERIFIED counts as a member here deliberately: that is
 * what isMemberStatus says everywhere else, and a verified company holds a
 * membership. Per-section verification is still on offer to it, because
 * verification is per section rather than per company.
 *
 * The company comes from the store rather than a prop because every section
 * already writes it there (useBankingSection and its siblings dispatch
 * setCurrentEditingCompany), so no section needs new plumbing to gate itself.
 */

/* Exported so the rule can be asserted without rendering six sections. */
export const canSeeVerifyOffer = (company) =>
  Boolean(company) && isMemberStatus(statusLadder(company));

export const MembershipVerifyNotice = ({ onUpload, className = "mt-3.5" }) => {
  const { currentEditingCompany } = useSelector((state) => state.company);

  if (!canSeeVerifyOffer(currentEditingCompany)) return null;

  return (
    <SectionNotice
      className={className}
      tone="offer"
      title={
        <>
          Get this section verified —{" "}
          <span className="text-[var(--success)]">free with your membership</span>
        </>
      }
      action={
        <Button variant="coralSolid" size="sm" className="gap-2" onClick={onUpload}>
          <UploadIcon size={13} />
          Upload documents
        </Button>
      }
    >
      Upload supporting documents for the data below and the TREVEX team will
      verify it. Verified data carries more weight with the buyers, banks and
      insurers viewing your profile.
    </SectionNotice>
  );
};

export default MembershipVerifyNotice;
